import { gaEvent } from './gaEvent';

const stripeKey = {
    au: process.env.MIX_STRIPE_KEY,
    nz: process.env.MIX_STRIPE_KEY_NZ,
};

$(function() {
    const paymentForm = $('#payment_form');
    const region = paymentForm.data('region') || 'au'; // Default to 'au' if not set.

    const stripe = Stripe(stripeKey[region]);
    const elements = stripe.elements();
    let card = elements.create('card', { hidePostalCode: true });
    card.mount('#cc_card');

    let isSubmitting = false;

    paymentForm.on('submit', async function(e) {
        e.preventDefault();
        if (isSubmitting) return; // Prevent multiple submissions
        isSubmitting = true;
        clearError();
        disableSubmitButton();
        gaEvent(paymentForm.data('ga-event'));

        try {
            await handlePaymentMethod();
        } catch (error) {
            console.error(error);
            return;
        } finally {
            enableSubmitButton();
            isSubmitting = false;
        }

        this.submit();
    });

    function disableSubmitButton() {
        $(".full-button[type='submit']").attr('disabled', true);
    }

    function enableSubmitButton() {
        $(".full-button[type='submit']").attr('disabled', false);
    }

    function setError(message) {
        $('#error_display').html(message);
        $('#payment_credit_card').addClass('has-error');
    }

    function clearError() {
        $('#error_display').html('');
        $('#payment_credit_card').removeClass('has-error');
    }

    async function handlePaymentMethod(method) {
        const paymentMethod = $("input[name='payment_method']:checked").val();
        if (paymentMethod == 'credit_card') {
            await handleStripe();
        }
    }

    async function handleStripe(status, response) {
        const { error, token } = await stripe.createToken(card);
        if (token) {
            $('#cc_token').val(token.id);
        } else {
            const message = error.message || 'An error occurred while processing your payment.';
            setError(message);
            throw new Error(message);
        }
    }
});
